import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { About, Resume, Portfolio, Home, Contact } from './container';
import { getUser } from './api';

const AppRoute = () => {
    const [profile, setProfile] = useState({})
    useEffect(() => {
        let isMounted = true;
        getUser((user) => {
            if (user && isMounted) {
                setProfile(user)
            }
        })
        return () => { isMounted = false };
    }, [])

    return (
        <Switch>
            <Route
                exact path='/'
                component={() => <Home user={profile} />}
            />
            <Route
                exact path='/home'
                component={() => <Home user={profile} />}
            />
            <Route
                exact path='/about'
                component={() => <About user={profile} />}
            />
            <Route
                exact path='/contact'
                component={() => <Contact user={profile} />}
            />
            <Route exact path='/resume' component={Resume}></Route>
            <Route exact path='/portfolio' component={Portfolio}></Route>
            {/* <Route exact path='/blogs' component={Blogs}></Route>
                        <Route exact path='/blog/:id' component={Blog}></Route>
                        <Route exact path='/blog/:id' component={Blog}></Route> */}
            {/* <Redirect from='/**' to='/home' /> */}
        </Switch>

    );
}

export { AppRoute };
